import script from "./userInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./userInfo.vue?vue&type=script&setup=true&lang=js"

import "./userInfo.vue?vue&type=style&index=0&id=0bab7a04&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bab7a04"]])

export default __exports__